var map = {
	"./light/sport/04sportDesc/19down.png": "LWZw"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6Iyt";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme ^\.\/.*\/sport\/04sportDesc\/19down\.png$
// module id = 6Iyt
// module chunks = 0